import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × SANDRO: Classic chic with algorithmic rhythm
// Neutral palettes, linear motifs, soft op-shadows
export function VasarelySandroMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <defs>
        <linearGradient id="sandro-neutral1" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#F0EBE3" />
          <stop offset="50%" stopColor="#E0D8CC" />
          <stop offset="100%" stopColor="#D0C5B5" />
        </linearGradient>
        <filter id="sandro-shadow">
          <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
          <feOffset dx="2" dy="2" result="offsetblur" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.2" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Elegant neutral background */}
      <rect x="0" y="0" width="794" height="1123" fill="url(#sandro-neutral1)" />

      <g transform="translate(397 540)">
        {/* Linear motifs */}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i * Math.PI) / 12;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 300}
              y2={Math.sin(angle) * 300}
              stroke="#C0B5A5"
              strokeWidth="1"
              opacity="0.2"
            />
          );
        })}

        {/* Soft op-shadows circles */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 40 + i * 25;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#B0A595"
              strokeWidth="1.5"
              opacity={0.3 - i * 0.02}
              filter="url(#sandro-shadow)"
            />
          );
        })}

        {/* Chic grid structure */}
        {Array.from({ length: 10 }).map((_, i) =>
          Array.from({ length: 14 }).map((_, j) => {
            const x = (i - 4.5) * 65;
            const y = (j - 6.5) * 70;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 30}
                y={y - 32}
                width="60"
                height="64"
                fill="none"
                stroke="#D0C5B5"
                strokeWidth="1"
                opacity="0.2"
              />
            );
          })
        )}

        {/* Algorithmic rhythm waves */}
        {Array.from({ length: 10 }).map((_, i) => {
          const offset = i * 30;
          return (
            <path
              key={i}
              d={`M ${-300} ${-250 + offset} Q ${0} ${-200 + offset} ${300} ${-250 + offset}`}
              fill="none"
              stroke="#B0A595"
              strokeWidth="1"
              opacity="0.15"
            />
          );
        })}

        {/* Central elegant element */}
        <rect x="-100" y="-100" width="200" height="200" fill="#C0B5A5" opacity="0.2" filter="url(#sandro-shadow)" />
        <rect x="-90" y="-90" width="180" height="180" fill="none" stroke="#B0A595" strokeWidth="2" />
        <rect x="-80" y="-80" width="160" height="160" fill="none" stroke="#A09585" strokeWidth="1" />

        {/* Soft geometric patterns */}
        {[
          { x: -60, y: -60, size: 120 },
          { x: -40, y: -40, size: 80 },
          { x: -20, y: -20, size: 40 },
        ].map((sq, i) => (
          <rect
            key={i}
            x={sq.x}
            y={sq.y}
            width={sq.size}
            height={sq.size}
            fill="none"
            stroke="#D0C5B5"
            strokeWidth="1"
            opacity={0.4 - i * 0.1}
          />
        ))}
      </g>

      {/* Classic chic */}
      <text x="397" y="1010" textAnchor="middle" fontFamily="sans-serif" fontSize="10" fill="#B0A595" letterSpacing="2">
        chic algorithmique
      </text>
    </g>
  );
}
